<template>
  <div class="createshopFood">
    <template>
      <div class="headline">基本信息</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="商品名称">
          <el-input v-model="input" placeholder="请输入内容" size="small" class="width220"></el-input>
        </el-form-item>

        <el-form-item label="商品分类">
          <el-select v-model="value" placeholder="请选择" class="width220">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="后台分类">
          <el-select v-model="value" placeholder="请选择" class="width220">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品编码">
          <el-input v-model="input" placeholder="设置后将会打印在小票上" size="small" class="width220"></el-input>
        </el-form-item>

        <el-form-item label="商品单位">
          <el-input v-model="input" placeholder="份" size="small" class="width220"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="hint">请上传300*300至1400*1400像素的图片或240*240至480*480像素的动图</div>
        </el-form-item>


      </el-form>
    </template>

    <template>
      <div class="headline">规格设置</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="添加规格">
          <el-button type="primary" plain>添加规格</el-button>
          <div class="hint">如大份/中份/小份等，不同规格可设置不同价格</div>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">商品备注</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="添加备注">
          <el-button type="primary" plain>添加备注</el-button>
          <div class="hint">如微辣/中辣/重辣等，设置后供顾客选择，且默认选中第一个被动项</div>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">售卖设置</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="售卖时间">
          <el-radio-group v-model="radio4" size="small">
            <el-radio-button label="1">全周</el-radio-button>
            <el-radio-button label="2">工作日</el-radio-button>
            <el-radio-button label="3">周末</el-radio-button>
            <el-radio-button label="4">自定义</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="售卖时间">
          <el-radio-group v-model="radio3" size="small">
            <el-radio-button label="1">全天</el-radio-button>
            <el-radio-button label="4">自定义</el-radio-button>
          </el-radio-group>
          <div class="hint">已选时段 00:00 至 23:59</div>
        </el-form-item>

        <el-form-item label="售卖时间">
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="仅在套餐中售卖"></el-checkbox><br>
            <el-checkbox label="每单限售份数"></el-checkbox><br>
            <el-checkbox label="每单起售份数"></el-checkbox><br>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </template>

    <template>
      <div class="headline">商品描述</div>
      <el-form ref="form" :model="formOne" label-width="90px" size="small">
        <el-form-item label="商品介绍">
          <EditorBar :isClear="isClear" @change="changeeditor" v-model="dataArray" class="width100"></EditorBar>
        </el-form-item>

        <el-form-item label="推荐标签">
          <el-radio-group v-model="radio2" size="small">
            <el-radio label="1" border>无</el-radio>
            <el-radio label="4" border>新品推荐</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="推荐标签">
          <el-radio-group v-model="radio1" size="small">
            <el-radio label="1" border>无</el-radio>
            <el-radio label="2" border>微辣</el-radio>
            <el-radio label="3" border>中辣</el-radio>
            <el-radio label="4" border>特辣</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </template>

    <div class="bottom_operate">
      <el-button type="primary" size="small" @click="goUp">确认</el-button>
      <el-button size="small" @click="goUp">取消</el-button>
    </div>
  </div>
</template>

<script>
import EditorBar from "@Components/public/wangEnduit";
export default {
  name: "createshopFood", // 创建买单活动
  components:{
    EditorBar
  },
  data() {
    return {
      dataArray: "",
      isClear: false,
      formOne: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      imageUrl: '',
      radio1: "1",
      radio2: "1",
      radio3: "1",
      radio4: "1",
      checkList: [],
      textarea: ""
    };
  },
  mounted() {},
  methods: {
    goUp() {
      this.$router.push("LibraryOfGoods")
    },
    // 编辑器
    changeeditor(val) {
      this.detail = val;
      console.log(val, this.dataArray);
    },
  }
};
</script>

<style lang="scss" scoped>
.createshopFood {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  padding-bottom: 100px;
  .width100 {
    width: 100%!important;
  }
  .headline {
    margin: 20px 0px;
    font-size: 14px;
    font-weight: 600;
  }
  .hint {
    font-size: 12px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  // .el-radio-group {
  //   line-height: 42px;
  // }
  .width220 {
    margin: 0 5px;
    width: 220px;
  }
  .width220-lft {
    margin: 0 5px;
    width: 220px;
    margin-left: -20px;
  }
  .width130 {
    margin: 0 5px;
    width: 130px;
    padding-bottom: 10px;
  }
  .width130-lft {
    margin: 0 5px;
    width: 130px;
    margin-left: -20px;
    padding-bottom: 10px;
  }
  .bottom_operate {
    background: #fff;
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px 10px 0px 0px;
  }
}
</style>

<style lang="scss">
.createshopFood {
  .el-input-group__append {
    padding: 0 10px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>
